import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ScalingTravelGrowthHero from "./sections/ScalingTravelGrowthHero";
import OurVenuePartners from "./sections/OurVenuePartners";
import TheCollaborativeProcess from "./sections/TheCollaborativeProcess";
import TemplateShowcase from "./sections/TemplateShowcase";
import PremiumServices from "./sections/PremiumServices";
import FromLensToLayout from "./sections/FromLensToLayout";
import ByTheNumbers from "./sections/ByTheNumbers";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import NosForfaitsPremium from "./sections/NosForfaitsPremium";
import BeginYourFreeTrial from "./sections/BeginYourFreeTrial";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ScalingTravelGrowthHero />
      <OurVenuePartners />
      <TheCollaborativeProcess />
      <TemplateShowcase />
      <PremiumServices />
      <FromLensToLayout />
      <ByTheNumbers />
      <ClientSuccessStories />
      <NosForfaitsPremium />
      <BeginYourFreeTrial />
      <Footer />
    </div>;
}